import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { ampli } from '../../../core/Tracking/Amplitude/__AUTO_GENERATED__';
import {
    TrackingProperties,
    useTrackEventAmplitude,
} from '../../../core/Tracking/Amplitude/Amplitude';
import {
    Carousel as CarouselDesignSystem,
    CAROUSEL_TEST_ID as CAROUSEL_TEST_ID_DS,
    CarouselProps as CarouselPropsDesignSystem,
    useCarousel as useCarouselDesignSystem,
} from '../../../design-system/components/carousel/Carousel';

type CarouselProps = Omit<CarouselPropsDesignSystem, 'nextLabel' | 'previousLabel'> & {
    trackingInformation?: {
        navClick: Omit<
            TrackingProperties<typeof ampli.carouselClicked>,
            'destination_slug' | 'direction'
        >;
    };
};

export const CAROUSEL_TEST_ID = CAROUSEL_TEST_ID_DS;

export const useCarousel = useCarouselDesignSystem;

export function Carousel({ trackingInformation, ...carouselProps }: CarouselProps) {
    const { formatMessage } = useIntl();
    const { trackEvent } = useTrackEventAmplitude();

    const handlePrevClick = useCallback(() => {
        if (trackingInformation?.navClick) {
            trackEvent((ampli, defaultProperties) => {
                ampli.carouselClicked({
                    ...defaultProperties,
                    ...trackingInformation.navClick,
                    direction: 'previous',
                });
            });
        }
    }, [trackEvent, trackingInformation?.navClick]);

    const handleNextClick = useCallback(() => {
        if (trackingInformation?.navClick) {
            trackEvent((ampli, defaultProperties) => {
                ampli.carouselClicked({
                    ...defaultProperties,
                    ...trackingInformation.navClick,
                    direction: 'next',
                });
            });
        }
    }, [trackEvent, trackingInformation?.navClick]);

    return (
        <CarouselDesignSystem
            {...carouselProps}
            nextLabel={formatMessage({ id: 'global.component.carousel.nav.next' })}
            previousLabel={formatMessage({ id: 'global.component.carousel.nav.previous' })}
            onPrevClick={handlePrevClick}
            onNextClick={handleNextClick}
        />
    );
}
